import * as React from 'react';

import { ToastContainer, ToastContainerProps } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import * as style from './AbaToastContainer.styl';

const CustomCloseButton = ({ closeToast }: { closeToast?(): void }) => (
  <span onClick={closeToast} className="icon icon-times toastify__close" />
);

export class AbaToastContainer extends React.Component<ToastContainerProps> {
  render() {
    return (
      <ToastContainer
        closeButton={<CustomCloseButton />}
        className={style.global}
        position="top-center"
        hideProgressBar
        autoClose={2000}
        closeOnClick
        icon={false}
      />
    );
  }
}
